import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChannelAuditListComponent } from './channel-audit-list/channel-audit-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuditChannelListService } from 'src/app/core/service/grid-data/grid-data-audit-channel.service';
import { ChannelAuditDetailsComponent } from './channel-audit-details/channel-audit-details.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [
    ChannelAuditListComponent,
    ChannelAuditDetailsComponent
  ],
  exports: [
    ChannelAuditListComponent,
    ChannelAuditDetailsComponent
  ],
    providers: [
      AuditChannelListService
    ]
})
export class ChannelAuditModule { }
